import types from '../types'
import Action from '../../types/Action'

const initialState = {
  loading: false,
  error: false,
  success: false,
  data: []
}

const applicationWelcomeAlertReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case types.GET_APPLICATION_WELCOME_ALERT_REQUESTED: {
      return {
        loading: true,
        error: false,
        success: false,
        data: []
      }
    }
    case types.GET_APPLICATION_WELCOME_ALERT_FULFILLED: {
      return {
        ...state,
        loading: false,
        success: true,
        data: action.payload
      }
    }
    case types.GET_APPLICATION_WELCOME_ALERT_REJECTED: {
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    }
    default:
      return state
  }
}

export default applicationWelcomeAlertReducer